import React from 'react';
import { cn } from '../../../lib/utils';

export enum AnomalyLevel {
    NO_ANOMALY = "None",
    MODERATE = "Moderate", 
    CRITICAL = "Critical"
}
  

interface AnomalyPillProps {
  anomalyLevel: AnomalyLevel;
  className?: string;
}

export const AnomalyPill: React.FC<AnomalyPillProps> = ({ 
    anomalyLevel, 
    className 
  }) => {
    const getAnomalyStyles = (level: AnomalyLevel) => {
      
      switch (level) {
        case AnomalyLevel.NO_ANOMALY:
          return {
            pill: 'bg-green-50',
            dot: 'bg-green-500',
            };
        case AnomalyLevel.MODERATE:
          return {
            pill: 'bg-[#FFF7D6]',
            dot: 'bg-yellow-500',
          };
        case AnomalyLevel.CRITICAL:
          return {
            pill: 'bg-red-50',
            dot: 'bg-red-500',
          };
        default:
          return {
            pill: 'bg-gray-50',
            dot: 'bg-gray-500',
          };
      }
    };
  
    const styles = getAnomalyStyles(anomalyLevel);
  
    return (
      <div className={cn(
        "inline-flex items-center gap-2 px-3 py-1 rounded-full text-xs font-semibold text-gray-600",
        styles.pill,
        className
      )}>
        <div className={cn("w-2 h-2 rounded-full", styles.dot)} />
        <span>{anomalyLevel}</span>
      </div>
    );
};

export const AnomalyNAPill = (
  <div
    className="
      inline-flex items-center justify-center
      px-2 py-[2px]
      gap-1
      rounded-[8px]
      border border-transparent
      bg-slate-100
      text-xs font-normal leading-4
      text-[#0A0A0A]
      font-sans
      opacity-60
    "
  >
    NA
  </div>
);